import { UIComponentProps, UIComponentState, UIComponentHandler, UIDataModel, UIComponentImpl } from '../uicomponent';
import { BaseContext } from '../../../utils/basecontext';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { UIComponentView } from '../uicomponentview';
import { AlertView } from './alertview';
import { AlertCSSStyleImpl } from './alertcss';

export interface AlertComponentProps extends UIComponentProps
{
    // alertType: AlertType;
    alertMessage:string;
    alertType: string;
    buttonTitle:string;
    onClick(data:any):void;
    onCloseButtonClick():void;
    // onTryAgainClick?():void;
}

export interface AlertComponentState extends UIComponentState
{
    alertType: string;
    buttonTitle:string;
    alertMessage:string;
}

export interface AlertComponentHandler extends UIComponentHandler
{
    onClick(data:any):void;
    onCloseButtonClick():void;
    // onTryAgainClick():void;
}

export class AlertComponent extends UIComponentImpl<AlertComponentProps, AlertComponentState, UIDataModel> implements AlertComponentHandler
{
    constructor(props: AlertComponentProps)
    {
        super(props);

        this.state = {alertType: props.alertType, alertMessage:props.alertMessage, buttonTitle:props.buttonTitle};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new AlertView(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new AlertCSSStyleImpl(applicationContext);
    }

    componentWillReceiveProps(nextProps: AlertComponentProps)
    {
        this.setState({alertType: nextProps.alertType, alertMessage:nextProps.alertMessage, buttonTitle:nextProps.buttonTitle});
    }

    

  onClick(data:any):void
  {
      this.props.onClick(data);
  }
  onCloseButtonClick():void
  {
     this.props.onCloseButtonClick();
  }
//   onTryAgainClick():void
//   {
      
//       if(this.props.onTryAgainClick !== undefined) 
//       {
//           this.props.onTryAgainClick();
//       }
//   }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/alert/alertcomponent.tsx